// extracted by mini-css-extract-plugin
export default {"highlight":"Journey_highlight__J-W6t","framePulse":"Journey_framePulse__lCZU+","chapterBar":"Journey_chapterBar__QwI8k"};